<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";

import {mapState, mapGetters} from "vuex";

import simplebar from "simplebar-vue";

import {with_acrf_token} from "@/methods";


export default {
  page: {
    title: "Support",
    meta: [{ name: "description", content: appConfig.description }]
  },
  computed: {
    ...mapGetters([
      'getAccountName',
      'getAccountId'
    ])
  },
  components: {
    Layout,
    SupportStatus: () => import('@/components/lazy/support/SupportStatus'),
    SupportTickets: () => import('@/components/lazy/support/SupportTickets')
  },
  methods: {
    reloadComponents() {
      this.renderComponents = false;
      this.$nextTick(() => {
        this.renderComponents = true;
      });
    }
  },
  created() {

  },
  data() {
    return {
      renderComponents: true
    }
  }
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-flex align-items-center justify-content-between">
      <h4 class="mb-0 font-size-18">
        Support
        <a href="javascript:void(0);" v-on:click="reloadComponents()">
          <i class="fas fa-sync"></i> Refresh
        </a>
      </h4>
      <div class="page-title-right bv-d-xs-down-none"><ol class="breadcrumb m-0">
        <li class="breadcrumb-item">
          <router-link to="/">
            <span class="text-danger text-uppercase">
              <i class="fad fa-clipboard-user" />
              CFTools Internal
            </span>
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <span aria-current="location">
            Support
          </span>
        </li>
      </ol>
      </div>
    </div>
    <div class="row d-flex">
      <SupportTickets v-if="renderComponents"></SupportTickets>
      <SupportStatus v-if="renderComponents"></SupportStatus>
    </div>
  </Layout>
</template>